import React, { useState } from "react";
import styled from "styled-components";
import { TextInputControlled } from "common/TextInputControlled";
import { validateIPv4IPv6 } from "common/api";
import { openSubscriberDetails } from "views/Status/Subscribers/Report";
import { RETURN_VIEW, PERIOD_DASHBOARD_TO_TIME_PERIOD } from "./utils";

const Wrapper = styled.div`
  width: 100%;
  max-width: 300px;
  cursor: auto;

  .input-group {
    margin-bottom: 0px;
  }
`;

const ERROR_TARGET = "Not an address nor a subscriber ID";

const targetOf = (value) =>
  value.length === 0
    ? undefined
    : validateIPv4IPv6(value)
      ? { addr: value }
      : { subsId: value };
      
function SubscriberDashboardSearch({ period }) {
  const [value, setValue] = useState("");
  const valueGiven = value.trim();
  const target = targetOf(valueGiven);
  const timePeriod = PERIOD_DASHBOARD_TO_TIME_PERIOD[period];

  const doOpen = () =>
    target === undefined
      ? undefined
      : openSubscriberDetails(target, timePeriod, RETURN_VIEW);

  return (
    <Wrapper>
      <TextInputControlled
        type="text"
        name="subscriberTarget"
        label="Subscriber:"
        value={value}
        placeholder="Address or subscriber ID"
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={(event) => event.key === "Enter" && doOpen()}
        addon={
          <button
            type="button"
            className="btn btn-link waves-effect"
            onClick={doOpen}
            disabled={target === undefined}
          >
            Go
          </button>
        }
      />
    </Wrapper>
  );
}

export default SubscriberDashboardSearch;
